import { Env } from '@/configuration';
import axios from '@/core/api/connector';
import { ContactMessage } from '../models/ContactMessage';


const sendContactMessage = async (contactMessage: ContactMessage) => {
  const endpointUri = Env.CoreApiOptions.endpointUrl('contact/send-contact-message');
  const response = await axios.post(endpointUri, contactMessage);
};

export default {
  sendContactMessage,
};
